export * from './lib/confirm-modal.module';
export { ConfirmModalService } from './lib/services/confirm-modal.service';
export * from './lib/interfaces/confirm-modal.interface';
